import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ToString } from 'src/shared/pipes/toString.pipe';

@NgModule({
declarations: [ToString],
imports: [],
exports: [ToString],
schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class PipesModule {}